// NCAA conferences and member schools (kept in sync with backend /api/ncaa/colleges)
export const NCAA_CONFERENCES = ["AHA", "ECAC", "HEA", "NEWHA", "WCHA"];

export const NCAA_COLLEGES = {
    AHA: ["Lindenwood", "Mercyhurst", "Penn State", "Robert Morris", "RIT", "Syracuse", "Delaware"],
    ECAC: ["Brown", "Clarkson", "Colgate", "Cornell", "Dartmouth", "Harvard", "Princeton", "Quinnipiac", "RPI", "St. Lawrence", "Union", "Yale"],
    HEA: ["Boston College", "Boston University", "UConn", "Holy Cross", "Maine", "Merrimack", "New Hampshire", "Northeastern", "Providence", "Vermont"],
    NEWHA: ["Assumption", "Franklin Pierce", "LIU", "Post", "Sacred Heart", "Saint Anselm", "Saint Michael's", "Stonehill"],
    WCHA: ["Bemidji State", "Minnesota", "Minnesota Duluth", "Minnesota State", "Ohio State", "St. Cloud State", "St. Thomas", "Wisconsin"],
};

export const NCAA_CONFERENCE_NAMES = {
    AHA: "Atlantic Hockey America",
    ECAC: "ECAC Hockey",
    HEA: "Hockey East",
    NEWHA: "New England Women's Hockey Alliance",
    WCHA: "Western Collegiate Hockey Association",
};

export const ALL_NCAA_SCHOOLS = Object.entries(NCAA_COLLEGES).flatMap(([conf, schools]) =>
    schools.map((s) => ({ school: s, conference: conf }))
);

export const DRAFT_FROM_LEAGUES = ["NCAA", "PWHL", "SDHL", "Liiga", "Other Pro", "Other"];
